import React, { Component } from "react";
import { Row, Col} from 'react-bootstrap';
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'

import LightboxComp from "./LightboxComp";
import './ProjectList.css';

const ProjectSummary = ({projectKey, project, images}) => {
  return (
    <Col xs={12} sm={6} md={4}>
      <Col xs={12} className="summary-region">
        <Row className="image-box">
          {images &&
            <LightboxComp images={images[projectKey]}>
            </LightboxComp>
          }
        </Row>
        <Row className="summary-box">
          {project.city &&
            <div className="summary-info">
               <i className="material-icons">location_on</i>
              <span className="summary-text">{project.city}</span>
            </div>
          }
          {project.houseType &&
            <div className="summary-info">
                <i className="material-icons">home</i>
              <span className="summary-text">{project.houseType}</span>
            </div>
          }
          {project.description &&
            <div className="summary-info">
              <p className="summary-description">{project.description}</p>
            </div>
          }
        </Row>
      </Col>
    </Col>
  )
}


class ProjectList extends Component {
  render() {
    if (!this.props.projects) {
      return <div />
    }
    return (
      <Col xs={12}>
        <Row className="auto-clear">
          {Object.keys(this.props.projects)
          .sort((a, b) => this.props.projects[a].index - this.props.projects[b].index)
          .map(key =>
            <ProjectSummary key={key}
                            projectKey={key}
                            project={this.props.projects[key]}
                            images={this.props.images}/>
          )}
        </Row>
      </Col>
    );
  }
}

export default compose(
  firebaseConnect(['images']),
  connect(
    ({ firebase }) => ({
      images: firebase.data.images,
    })
  )
)(ProjectList)


// WEBPACK FOOTER //
// ./src/ProjectList.js